import { Card } from "antd";

import "./style.css";
const Rules = () => {
  return (
    <div className="rules-container">
      <Card className="rules-card">
        <h3>قوانین و مقررات</h3>
        <div className="rules-paragraph">
          <p>
            استفاده از خدمات وبسلا به منزله قبول تمامی شرایط و مقررات زیر است و
            هر گونه ادعا یا اعتراض آتی در این خصوص را بلا اعتبار می نماید. این
            شرکت مجاز به تغییر در شرایط استفاده از خدمات نرم افزاری وبسلا در طول
            زمان بوده و آن را در قالب پیامک و ایمیل به تمامی کاربران اطلاع رسانی
            نماید. بدیهی است، صرف استفاده کاربران از خدمات وبسلا به منزله پذیرش
            و اعلام رضایت نسبت به شرایط جدید و قبول آن است.
          </p>
          <p>
            توجه نمایید که هر گونه علامت، عدد، کلمه، تصویر یا نشان الکترونیک که
            مثبت هویت امضا کننده باشد و به این سند یا سایر اسناد صادره در این
            زمینه ملحق شود، به منزله امضای الکترونیک و همانند امضای دست نویس
            واجد اعتبار کاربر خواهد بود و امضا کننده را به مفاد سند ملتزم می
            نماید.
          </p>
          <h5>ماده 1 – تعاریف و اصطلاحات</h5>
          <p>
            1-1- مرکز درمانی ارایه دهنده خدمت: مراکز درمانی اعم از کلینیک،
            تصویربرداری، آزمایشگاه و ... که طبق پرونده بهره برداری و مجوزات
            مربوطه، ارایه دهنده خدمات درمانی به مراجعه کنندگان می باشند.
          </p>
          <p>
            1-2- خدمت گیرنده (کاربر): شخص حقیقی متقاضی اخذ خدمت از مراکز درمانی
            و وبسلا را به عنوان پل ارتباطی جهت اخذ نوبت آنلاین انتخاب نموده است.
          </p>
          <p>
            1-3- تاریخ و زمان رزرو نوبت: تاریخ و زمان تخصیص داده شده به خدمت
            گیرنده جهت مراجعه به مرکز درمانی جهت دریافت خدمات است. پیشنهاد می
            گردد خدمت گیرنده (کاربر) حداقل 30 دقیقه قبل از زمان رزرو نوبت در
            مرکز درمانی حضور داشته باشد.
          </p>
          <p>
            1-4- وبسلا (شرکت): شرکت نوآفرینان ستاره هوشمند پارس (سهامی خاص) به
            شماره ثبت 70956 (با نام تجاری وبسلا) به عنوان سکو غیرمستقیم ارایه
            دهنده خدمات مراکز درمانی به مراجعه کنندگان است. مراجعه کنندگان می
            توانند با مراجعه به فضای مجازی (وب سایت) از این پل ارتباطی جهت اخذ
            نوبت از مراکز درمانی اقدام نمایند.
          </p>
          <p>1-5- پزشک: منظور پزشک شاغل و طرف قرارداد مرکز درمانی است.</p>
          <p>
            1-6- اعتبار: مبلغی است که متقاضیان در حساب کاربری خود به منظور
            استفاده از خدمات وبسلا دارند. این مبلغ به صورت پرداخت از طریق سامانه
            بانکی و کارت‌های عضو شبکۀ شتاب و یا به صورت هدیه از طریق وبسلا در
            حساب کاربری کاربر طبق شرایط و مقررات حاضر منظور و محاسبه می گردد.
          </p>
          <p>
            1-7- اطلاعات محرمانه: اطلاعاتی که توسط کاربران متخصص و متقاضیان در
            اختیار وبسلا قرار گرفته و اعم از اطلاعاتی که به صورت مستقیم از سوی
            کاربران وارد می‌شود و همچنین اطلاعاتی که به صورت خودکار و در نتیجۀ
            بهره برداری از خدمات وبسلا در اختیار شرکت قرار داده می‌شود.
          </p>
          <h5>ماده 2 – حساب کاربری</h5>

          <p>
            2-1- کاربران با ثبت نام در وبسلا و همچنین با هر بار استفاده از خدمات
            وبسلا می‌پذیرند که قوانین و مقررات جاری وبسلا را به صورت کامل مطالعه
            کرده و با اطلاع کامل از شرایط و معانی آن اقدام به استفاده از خدمت یا
            محصول کرده اند . این قوانین و مقررات ممکن است در طول زمان تغییر
            نماید و بنابراین استفادۀ مستمر کاربران از وبسلا به معنی پذیرش هرگونه
            تغییر در قوانین و مقررات آن است.
          </p>

          <p>
            2-2- کاربران به منظور استفاده از خدمات وبسلا ملزم به ایجاد حساب
            کاربری می باشند. تنها اشخاصی که بیش از ۱۸ سال سن و واجد اهلیت قانونی
            باشند می‌توانند اقدام به ساختن حساب کاربری در وبسلا کنند. برای
            استفاده از وبسلا، کاربر مذکور می بایست اطلاعاتی از جمله نام، نام
            خانوادگی، آدرس پست الکترونیکی و شماره همراه خود را در سامانۀ وبسلا
            ثبت نماید.
          </p>
          <p>
            2-3- کاربر می‌پذیرد اطلاعات خواسته شده را به صورت صحیح و به‌ روز در
            سامانه وبسلا وارد نماید و مسئول عدم صحت اطلاعات اعلام شده ، شخص
            کاربر می‌باشد. در صورت اثبات خلاف این موضوع، شرکت مجاز به پیگیری
            قضایی و قانونی نزد مراجع صالح می‌باشد.
          </p>

          <p>
            2-4- هر فرد تنها می‌تواند یک حساب کاربری به عنوان خدمت گیرنده در
            وبسلا داشته باشد. در صورتی که شرکت اطلاع یابد که به نام یک شخص
            حقیقی، حساب‌های کاربری متعدد وجود دارد، شرکت مجاز خواهد بود نسبت به
            قطع خدمات و غیرفعال نمودن حساب ‌های کاربری مذکور اقدام نماید.
          </p>

          <p>
            2-5- هر کاربر با ثبت‌ نام و ایجاد حساب کاربری در وبسلا، صحت انتساب
            تمام پیام‌های صادره از حساب کاربری خویش را پذیرفته و درنتیجه حق
            هرگونه اعتراض یا ادعای آتی (مبنی بر انکار، تردید یا جعل داده‌ی
            پیام‌های ارسالی) را از خویش سلب و اسقاط می‌نماید.
          </p>
          <p>
            2-6- مسئولیت تمامی فعالیت‌هایی که از طریق حساب کاربری انجام می‌شود
            مطلقاً به عهده‌ی شخص کاربر است، درنتیجه ضروری است که کاربر در حفظ
            اطلاعات حساب کاربری خود، ازجمله نام کاربری و رمز عبور، حداکثر
            اقدامات لازم را مبذول دارد و از این طریق مانع استفاده‌ی دیگران از آن
            گردد. همچنین ضروری است که کاربر در صورت ظن به دسترسی ثالث به‌حساب
            کاربری خویش ، شخص کاربر در اسرع وقت نسبت به تغییر رمز عبور خود اقدام
            نماید و در صورت لزوم شرکت را مطلع کند تا حساب کاربری مذکور را مسدود
            نماید.
          </p>

          <p>
            2-7- کاربر حق ندارد به اشخاص حقیقی و حقوقی دیگر اجازه استفاده از
            حساب کاربری خود را بدهد و یا حساب خود را به فرد دیگری منتقل نماید.
          </p>

          <p>
            2-8- در شرایط خاصی ممکن است از کاربر برای استفاده از خدمات، درخواست
            احراز هویت شود، در چنین شرایطی اگر کاربر اطلاعات کافی در اختیار شرکت
            قرار ندهد، شرکت می‌تواند حساب کاربری وی را مسدود کرده و از ارائۀ
            خدمات به کاربر خودداری نماید.
          </p>
          <h5>ماده 3 – تعهدات کاربران وبسلا</h5>
          <p>
            3-1- خدمت گیرنده (کاربر) متعهد است که در استفاده از خدمات وبسلا
            تمامی قوانین جمهوری اسلامی ایران را رعایت نماید، نرم‌ افزار را برای
            اهداف قانونی به کار گیرد و در همه حال، با در نظر گرفتن حیثیت تجاری
            نرم‌ افزار وبسلا و شرکت، مرتکب رفتاری نشود که اعتبار نرم ‌افزار
            وبسلا را خدشه‌ دار نماید. مسئولیت هر نوع اقدام کاربر که منجر به بروز
            آسیب جانی یا مالی گردد به عهده‌ی کاربر است و شرکت در این خصوص
            مسئولیتی نخواهد داشت.
          </p>
          <p>
            3-2- خدمت گیرنده (کاربر) متعهد می‌شوند هیچ‌گاه از خدمات وبسلا به
            صورتی که به وبسلا یا شرکای آن صدمه‌ای وارد کند ، استفاده نکنند. در
            صورتی که کاربر نسبت به سوءاستفاده از امکانات فراهم شده در خدمات
            وبسلا در جهت منافع شخصی و یا آسیب ها اعم از مادی و یا معنوی به منافع
            شرکت اقدام نماید، شرکت ضمن داشتن حق قطع خدمات و غیرفعال نمودن حساب
            کاربری، مجاز خواهد بود با مراجعه به مراجع قضایی و یا سایر مراجع
            ذیصلاح قانونی نسبت به مطالبه جبران خسارات وارده اقدام نماید.
          </p>
          <p>
            3-3- خدمت گیرنده (کاربر) متعهد می شوند پس از اتمام خدمت از هیچ بخش
            از اطلاعاتی که در نتیجه استفاده از نرم افزارهای وبسلا ، از یکدیگر
            کسب کرده است ، استفاده‌ای نکند. طبعاً ذخیره کردن اطلاعات در دستگاه
            تلفن همراه یا به هر شیوه دیگری نیز مغایر با قوانین وبسلا خواهد بود.
            لذا کاربران متعهد خواهند بود ، فقط در شرایط ضروری و در مدت زمان
            ارائه خدمت از اطلاعات یکدیگر مطابق با عرف جامعه و قوانین جمهوری
            اسلامی ایران استفاده کنند.
          </p>

          <p>
            3-4- مسئولیت تامین اینترنت و سخت‌افزار لازم و همچنین پرداخت
            هزینه‌های مربوط به آنها برای استفاده از خدمات وبسلا به عهده خدمت
            گیرنده (کاربر) است.
          </p>

          <p>
            3-5- خدمت گیرنده (کاربر) تنها مجاز است از وبسلا برای رفع نیازهای
            شخصی استفاده کند و باید از فروش یا استفاده‌ی تجاری از خدمات آن
            اجتناب نماید. در صورت تخلف، چهار برابر هزینه‌ی خدمات انجام‌شده از
            سوی متخلف به‌عنوان وجه التزام تخلف از وی اخذ خواهد شد. وصول این مبلغ
            نافی حق شرکت برای طرح دعوای جبران خسارت وارده نخواهد بود. بدیهی است
            این حکم شامل اشخاص حقوقی نیز میباشد.
          </p>
          <p>
            3-6- خدمت گیرنده (کاربر) متعهد میگردد که تنها زمانی که قصد استفاده
            از خدمت را دارد اقدام به ثبت درخواست نماید.
          </p>
          <p>
            3-7- وبسلا میتواند در صورت وجود مغایرت اطلاعات فردی ثبت شده خدمت
            گیرنده (کاربر) طبق قوانین و مقررات شرکت اقدام به مسدود نمودن حساب
            کاربری خدمت گیرنده (کاربر) نماید.
          </p>
          <p>
            3-8- خدمت گیرنده (کاربر) اقرار می‌نماید که با افتتاح حساب کاربری در
            وبسلا تنها مجوز استفاده‌ی غیر انحصاری، غیر قابل ‌انتقال و محدود از
            خدمات آن را دریافت می‌کند و به ‌این ‌ترتیب مدعی مالکیت یا حقی نسبت
            به وبسلا (اعم از کپی‌ رایت، علامت تجاری و سایر حقوق معنوی آن) نیست،
            در غیر موارد مصرح در این قرارداد اجازه‌ی استفاده از نام و علامت
            تجاری و خدمات نرم ‌افزارهای وبسلا را ندارد و در همه حال متعهد به
            رعایت حقوق معنوی شرکت نسبت به نرم‌ افزارها و ملحقات آن خواهد بود.
          </p>
          <p>
            3-9- خدمت گیرنده (کاربر) می‌پذیرد که قرارداد حاضر یک قرارداد قابل
            رجوع و جایز از سوی شرکت است و شرکت می‌تواند هر زمان تنها به صلاحدید
            خود و بدون نیاز به تدارک هیچ‌گونه دلیلی، یک حساب کاربری را مسدود کند
            و مانع استفاده‌ی کاربر از خدمات وبسلا گردد.
          </p>
          <p>
            3-10- خدمت گیرنده (کاربر) متعهد است تمامی تغییرات، الحاقات و
            اصلاحاتی را که توسط شرکت از طریق پیامک، ایمیل یا نرم ‌افزارهای وبسلا
            در خصوص استفاده از خدمات وبسلا و شرایط آن برای کاربر ارسال می‌گردد
            را مطالعه نماید و در صورت عدم موافقت، ضمن توقف استفاده از خدمات،
            مخالفت خود را بصورت رسمی به اطلاع شرکت برساند. عدم اطلاع رسانی به
            شرکت و یا استمرار استفاده از نرم افزارهای وبسلا، به منزله امضای دست
            ‌نویس دارای آثار حقوقی است و امضاکننده را به مفاد سند مزبور متعهد و
            ملتزم می‌نماید.
          </p>
          <p>
            3-11- متقاضی در طول دریافت خدمات ملزم به رعایت قوانین جمهوری اسلامی
            ایران از هر نظر می باشد و درنتیجه رعایت مقررات مربوط به حجاب برای
            بانوان و... ، برای متقاضی الزامی است ، که در غیر این صورت مسئولیت
            کلیه پیشامدهای احتمالی بر عهده متقاضی می‌باشد.
          </p>
          <p>
            3-12- خدمت گیرنده (کاربر) موظف است در تاریخ و زمان مقرر (تاریخ رزرو
            نوبت) در مرکز خدمات (نشانی‌ای که در درخواست خدمات ثبت ‌شده است) حضور
            داشته باشد، در غیر این صورت وبسلا (شرکت) مجاز خواهد بود هزینه‌ کنسلی
            نوبت یا هزینه عدم مراجعه به موقع خدمت گیرنده را طبق قوانین و مقررات
            کنسلی نوبت مرکز درمانی (به نفع مرکز درمانی) از اعتبار او کسر یا از
            نامبرده وصول نماید.
          </p>
          <p>
            3-13- خدمت گیرنده (کاربر) با استفاده از خدمات وبسلا (شرکت) می پذیرد
            که قوانین نوبت دهی مراکز درمانی را می پذیرد. بدیهی است هر مرکز
            درمانی قوانین نوبت دهی مختص خود را دارد و وبسلا (شرکت) این قوانین را
            در دو مرحله ، به ترتیب صفحه مرور و تایید نوبت (قبل از انتقال به
            درگاه بانکی) و صفحه اعمال کنسلی نوبت (پروفایل کاربر – بعد از اخذ
            نوبت) به اطلاع خدمت گیرنده (کاربر) می رساند.
          </p>
          <p>
            3-14- خدمت گیرنده (کاربر) موظف است هزینه‌ خدمات آنلاین را به یکی از
            طرق پیش ‌بینی‌ شده پرداخت نماید. پس از ارسال درخواست خدمات یا پس از
            پایان خدمات (در فرضی که شرایط خدمات پایان یابد) . متقاضی نمی‌تواند
            به میزان هزینه‌ خدمات آنلاین اعتراض کند و یا اینکه پس از پرداخت ،
            تقاضای استرداد مبلغ پرداختی را خارج از شرایط مذکور در این قرارداد
            بنماید. درصورتی‌که متقاضی به هر علت از جمله به خاطر اشکالات فنی،
            ارتباطی، قطع شبکه‌ تلفن همراه، بروز نقص در نرم ‌افزار و ... نتواند
            هزینه‌ی خدمات را پرداخت کند، شرکت مجاز خواهد بود که این هزینه را از
            اعتبار کاربر در وبسلا کسر و یا مبلغ آن را از نامبرده وصول نماید و
            متقاضی نمی‌تواند نسبت به این اقدام اعتراضی داشته باشد.
          </p>
          <p>
            3-15- خدمت گیرنده (کاربر) می‌پذیرد که وبسلا ممکن است از ارسالSMS
            (پیامک) به عنوان راه ارتباطی خود با وی استفاده کند. کاربر می‌تواند
            درخواست کند که ارسال این پیام ‌ها قطع شود اما می‌پذیرد که با انصراف
            از دریافت این پیام‌ها، ممکن است در استفاده از سرویس با مشکل مواجه
            شود.
          </p>

          <p>
            3-16- خدمت گیرنده (کاربر) می‌پذیرد اعتبار هدیه ای که در حساب کاربری
            خود در وبسلا دارد مستقل از روش کسب آن فقط برای استفاده از خدمت ارایه
            شده توسط وبسلا قابل استفاده است و امکان دریافت این وجه را به صورت
            نقد ندارد.
          </p>
          <p>
            3-17- وبسلا ممکن است کدهایی به منظور هدیه به کاربران ارائه کند که با
            وارد کردن این کدها در سامانه و برنامه های موبایل، تخفیفاتی به وی
            داده ‌شود و یا مبلغ مشخصی به اعتبار کاربر در وبسلا اضافه شود. لذا
            کاربر می‌پذیرید که اجازه انتقال یا فروش آنها را به افراد دیگر ندارد.
            همچنین کاربران مجاز نیستند این کدها را به صورت عمومی منتشر کنند (حتی
            اگر وبسلا اقدام به انتشار آنها در فضاهای دیگر کرده باشد) . مگر اینکه
            وبسلا رسما این اجازه را به آنها داده باشد.
          </p>
          <p>
            3-18- خدمت گیرنده (کاربر) می‌پذیرد کدهایی که جهت ارایه تخفیف به وی
            داده می‌شود ممکن است منقضی شوند. از آنجایی که وبسلا برای ارائه این
            کدها هزینه ای از متقاضیان دریافت نمی‌کند، این حق برای وبسلا محفوظ
            است که مبلغ یا درصد تاثیر این کدها را حتی پس از انتشار آنها تغییر
            دهد یا در صورت لزوم آنها را باطل کند. همچنین در صورتی که وبسلا تشخیص
            دهد که استفاده از این کد به دلیل خطای فنی یا تخلف صورت گرفته است و
            یا غیر قانونی بوده است می‌تواند این کدها یا اعتباری که در نتیجه
            استفاده از آنها به حساب متقاضی اضافه شده است را باطل یا حذف کند.
          </p>
          <p>
            3-19- کاربر حق ندارد هیچ‌گونه تلاشی در جهت استخراج سورس کد(Source
            Code) نرم ‌افزارهای وبسلا شامل دیکامپایل (Decompile)، مهندسی
            معکوس(Reverse Engineering) یا فعالیت‌ های مشابه انجام دهند، مگر
            اینکه اجازه چنین کاری به صورت قانونی صادر شده باشد.
          </p>
          <p>
            3-20- کاربر مجاز نیست با استفاده از روش ‌های Framing یا Mirroring یا
            روش ‌های دیگر نسخه دیگری از وبسلا را روی سرورهای دیگر ارائه کند.
            همچنین وی مجاز نیست در نرم‌افزار وبسلا یا در روش ارائه سرویس تغییر
            یا اخلالی ایجاد کند. کاربر حق ندارد برنامه یا اسکریپتی با هدف ایندکس
            گذاری (Indexing) ، مطالعه یا هر گونه فعالیت داده ‌کاوی روی سرویس
            اجرا کند.
          </p>
          <p>
            3-21- کاربر حق ندارد هیچ فعالیتی در راستای حصول دسترسی غیرقانونی و
            غیر متداول به هیچ بخش وبسلا انجام دهد.
          </p>
          <h5>تعهدات وبسلا</h5>
          <p>
            4-1- وبسلا عامل ارائه خدمات نیست ، بلکه تنها یک خدمات نرم‌افزاری
            (سکو غیر مستقیم ارایه دهنده آنلاین خدمات درمانی) که از این طریق
            ارتباط بین خدمت گیرندگان (کاربران) و مراکز درمانی را بر انجام یک
            خدمت فراهم آورده و تلاش دارد تا فرایند انجام خدمات یاد شده را تسهیل
            نماید. لذا هر نوع خدماتی که در قالب این پلتفرم صورت می‌گیرد یک
            قرارداد مستقل فی‌ ما بین خدمت گیرنده (کاربر) و مراکز درمانی است و
            وبسلا تنها زمینه‌ی انعقاد این قرارداد را مهیا می‌کند. تأکید می‌شود
            که شرکت هیچ‌گونه مسئولیتی - اعم از حقوقی و کیفری - در قبال اتفاقات
            حین انجام خدمات در مقابل کاربران (اعم از خدمت گیرندگان ، مراکز
            درمانی ، پزشکان شاغل در مراکز یا اشخاص ثالث) و همچنین تعهد یا
            مسئولیتی در مورد استخدام و روابط کارفرمایی با افراد ثبت نام شده در
            سیستم را ندارد.
          </p>
          <p>
            4-2- وبسلا با تمام امکانات خود از جمله مرکز تماس، واحد رسیدگی به
            شکایات و فرآیند میانجیگری تمامی تلاش خود را جهت رضایت کاربران و رفع
            اختلافات ایجاد شده در زمان ارائه خدمات و نیز ایجاد صلح و سازش فی
            مابین خدمت گیرندگان (کابران) ، مراکز درمانی و پزشکان شاغل در مراکز
            درمانی را دارد.
          </p>

          <p>
            4-3- چنانچه هر یک از کاربران وبسلا در زمان استفاده از خدمات آن با
            مشکلی مواجه شوند برابر شرایط فوق می‌توانند شکایت خود را از طریق
            ایمیل info@websla.ir یا مرکز تماس ۲۴ ساعته و واحد رسیدگی به شکایات
            وبسلا مطرح و شرکت پیگیری لازم و تلاش خود را جهت حل و فصل اختلافات
            بعمل خواهد آورد.
          </p>

          <p>
            4-4- وبسلا متعهد به تلاش ، برای ارائه‌ی خدمات با کیفیت است و میکوشد
            تا با به ‌روز رسانی نرم ‌افزارها متناسب با نیاز کاربران ،کیفیت و نوع
            خدمات ارائه ‌شده را ارتقا بخشد.
          </p>

          <p>
            4-5- وبسلا تلاش خود را جهت فراهم نمودن امکان استفاده از خدمات نرم
            ‌افزاری خود توسط دستگاه‌ های کاربران محترم می‌کند . اما تضمینی نسبت
            به اجرا شدن آن روی همۀ دستگاه‌ها یا همۀ شبکه‌های ارتباطی (اینترنت،
            شبکه تلفن‌همراه و …) نخواهد داد.
          </p>
          <p>
            4-6- تمامی اطلاعات کاربران اعم از مراکز درمانی ، خدمت دهندگان و خدمت
            گیرندگان بعنوان اطلاعات محرمانه نزد وبسلا محافظت شده و دسترسی به آن
            توسط اشخاص ثالث ممنوع بوده مگر برابر تصمیم مقام صالح. بنابراین در
            صورت درخواست و صدور دستور مقتضی از سوی مراجع قضایی، وبسلا (شرکت)
            مکلف به ارایه اطلاعات کاربران اعم از متقاضیان ، مراکزدرمانی و یا
            متخصصان به مراجع مذکور می‌باشد.
          </p>

          <p>
            4-7- نظر به این‌که وبسلا تنها خدمات نرم‌افزاری ارائه می‌دهد و در
            انجام خدمات دخالت ندارد، شرکت تمام تلاش خود را برای رفع مشکلات مربوط
            به کیفیت انجام خدمات، سلامت روحی و جسمی متخصصان، صلاحیت و مهارت لازم
            متخصصان، زمان دریافت خدمات و کیفیت خدماتی که متخصص به متقاضی ارائه
            می‌دهد انجام خواهد داد و از طریق سیستم های پشتیبانی، مرکز تماس و شعب
            مراجعه حضوری، سعی در رفع اختلافات به وجود آماده خواهد نمود.
          </p>
          <p>
            4-8- شرکت هیچ‌گونه مسئولیتی در خصوص عملکرد اشخاص ثالث - که ممکن است
            موجب حدوث نقص یا اشکال و ایرادی در حساب کاربری کاربر گردد - نخواهد
            داشت.
          </p>
          <h5>ماده 5 – هزینه ها و پرداخت</h5>

          <p>
            5-1- خدمت گیرنده (کاربر) آگاه است که استفاده از وبسلا می‌تواند
            هزینه‌هایی برای او داشته باشد.
          </p>
          <p>
            5-2- امکان استرداد هزینه‌هایی که کاربر به وبسلا می‌پردازد تنها مطابق
            شرایطی که در این قرارداد آمده ، امکان پذیر میباشد.
          </p>
          <p>
            5-3- هزینۀ خدمات ارائه شده از سوی وبسلا ، ممکن است بسته به ویژگی‌های
            خدمات از جمله نوع ، زمان درخواستی ، مدت زمان تخمینی جهت ارایه خدمات،
            مکان و یا عوامل دیگر متغیر باشد. در هر صورت رقم اعلام شده از سوی
            وبسلا بر اساس استانداردهای موجود و صلاحدید شرکت تعیین گردیده است و
            در صورت پذیرش از سوی کاربر اعم از متقاضی و متخصص ، هیچ یک حق طرح
            هرگونه ادعا و اعتراضی دراین خصوص را نخواهد داشت.
          </p>
          <p>
            5-4- خدمت گیرنده (کاربر) می‌پذیرد هزینه بعضی از خدمات به طور تقریبی
            در وبسلا از طرف مراکز درمانی مشخص شده و ممکن است با توجه به جزئیات
            خدمت مورد نظر و پس از انجام بازدید توسط متخصص تغییر در آن اعمال گردد
            و قیمت نهایی پس از بازدید به وی اعلام خواهد شد ، لذا در صورت تایید
            کاربر ، اعتراضی نسبت به هزینه خدمت نمی‌تواند داشته باشد.
          </p>
        </div>
      </Card>
    </div>
  );
};

export default Rules;
